/* eslint-disable @wyz/module/no-relative-import */
import { Icon } from '@wyz/ui';
import { Trans } from '~/common/context';
import { TranslationKeys } from '~/common/types';
import './log-type-switcher.scss';

export type LogType = 'modifications' | 'connections';

const TABS: Array<{
  value: LogType;
  icon: 'quote-service' | 'account-circle';
  labelKey: keyof TranslationKeys;
}> = [
  {
    value: 'modifications',
    icon: 'quote-service',
    labelKey: 'app.logs.tab.modifications.title',
  },
  {
    value: 'connections',
    icon: 'account-circle',
    labelKey: 'app.logs.tab.connections.title',
  },
];

export function LogTypeSwitcher({
  active,
  onChange,
}: {
  active: LogType;
  onChange: (type: LogType) => void;
}) {
  return (
    <div className='log-type-switcher' role='tablist'>
      {TABS.map((tab) => {
        const isActive = tab.value === active;

        return (
          <button
            key={tab.value}
            type='button'
            role='tab'
            aria-selected={isActive}
            onClick={() => onChange(tab.value)}
            className={`log-type-tab${isActive ? ' log-type-tab--active' : ''}`}
          >
            <Icon icon={tab.icon} size='sm' className='log-type-tab__icon' />
            <span className='log-type-tab__title'>
              <Trans i18nKey={tab.labelKey} />
            </span>
            <Icon icon={isActive ? 'arrow-down' : 'arrow-right'} size='xs' />
          </button>
        );
      })}
    </div>
  );
}
